<template>
  <user-course-register>
    <template v-slot:step4>
      <v-card flat>
        <v-card-text>
          <v-switch v-model="showQuiz"
                    :label="(showQuiz ? 'O Curso possui Quiz' : 'O curso não possui Quiz')"></v-switch>

          <div v-if="showQuiz">
            <v-row>
              <v-col cols="12" sm="12" md="3" v-if="courseHasModules" class="pt-0">
                <v-list class="pt-0 v-list-modules">
                  <v-subheader class="ml-1">Módulos</v-subheader>
                  <div class="text-center" v-if="loadingModules">
                    <v-progress-linear indeterminate></v-progress-linear>
                    Carregando módulos

                  </div>
                  <v-list-item-group color="primary">
                    <v-list-item
                      ripple
                      v-for="(module, $index) in modules"
                      :key="$index"
                      v-bind:class="{'v-item--active v-list-item--active': moduleId === module._id}"
                      :style="moduleId !== module._id ? 'background-color:#D7E0E9 !important; color:#525252' : ''"
                      @click="selectModule(module, $index)"
                      inactive
                      active-class="v-list-item--active-2"
                      class="py-1"
                    >
                      <!--
                                          <v-list-item
                                            ripple
                                            v-for="(module, $index) in modules"
                                            :key="$index"
                                            @click="selectModule(module, $index)"
                                            class="py-1"
                                          >
                      -->
                      <v-list-item-content>
                        <v-list-item-title v-text="module.title"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>

              <v-col cols="12" sm="12" :md="!courseHasModules ? 12 : 9" class="pt-0">
                <div class="text-center mt-5" v-if="loadingQuiz">
                  <v-progress-linear indeterminate></v-progress-linear>
                  Carregando quiz
                </div>

                <div v-else>
                  <v-row v-if="courseHasModules && !moduleId" row wrap>
                    <v-col cols="12">
                      <v-alert class="mt-0 white-text" type="warning">
                        Selecione o módulo
                      </v-alert>
                    </v-col>
                  </v-row>
                  <v-row v-else row wrap>
                    <v-col cols="12" md="12" v-if="moduleTitle">
                      <h4>{{ moduleTitle }}</h4>
                      <v-switch v-model="moduleHasQuiz"
                                :label="(moduleHasQuiz ? 'O módulo possui Quiz' : 'O módulo não possui Quiz')"></v-switch>

                    </v-col>

                    <v-row row wrap v-if="moduleHasQuiz || !courseHasModules" class="mx-1">
                      <v-col cols="12" md="12">
                        <v-text-field v-model="quiz.title" label="Título" required color="blue"></v-text-field>
                      </v-col>

                      <v-col cols="12" md="12">
                        <h4>Perguntas</h4>
                        <v-btn color="success" :disabled="sending" dark @click="addQuestion()"
                               class="ml-0 mt-0 add-quiz text-white">
                          Adicionar pergunta
                        </v-btn>
                      </v-col>

                      <v-col cols="12" sm="12" md="6" v-for="(question, $index) in quiz.questions" :key="$index">
                        <div class="card-quiz">
                          <v-badge xs12 right overlap>
                            <template v-slot:badge>
                              <span class="white--text">{{ quiz.questions.length - ($index) }}</span>
                            </template>
                            <v-btn :disabled="sending" v-if="quiz.questions.length > 1" fab dark small color="red"
                                   class="delete-quiz" @click="removeQuestion($index)">
                              <v-icon dark>delete</v-icon>
                            </v-btn>

                            <v-col md="12" class="px-0 pb-0">
                              <vue-editor v-model="question.ask"></vue-editor>
                              <!--<v-text-field v-model="question.ask"
                                label="Pergunta"
                                outlined
                                required
                                color="blue"
                                class="card-quiz-question">
                              </v-text-field>-->
                            </v-col>

                            <v-col md="12">
                              <v-row v-for="(answer, $indexAnswer) in question.answers" :key="$indexAnswer">
                                <v-checkbox
                                  v-model="answer.correct"
                                  hide-details
                                  color="blue"
                                  tabindex="-1"
                                  class="shrink"
                                ></v-checkbox>
                                <!--
                                                        <v-checkbox
                                                          v-model="answer.correct"
                                                          hide-details
                                                          color="blue"
                                                          tabindex="-1"
                                                          class="shrink"
                                                          @click="changeCorrect($index, $indexAnswer)"
                                                        ></v-checkbox>
                                -->
                                <v-text-field v-model="answer.text" label="Resposta" required class="card-quiz-answer"
                                              solo></v-text-field>

                                <v-icon v-if="question.answers.length > 4" @click="removeAnswer($index, $indexAnswer)"
                                        color="red"
                                        class="delete-question"
                                        dark>
                                  cancel
                                </v-icon>
                              </v-row>
                            </v-col>

                            <!--
                            <v-layout v-for="(answer, $indexAnswer) in question.answers" :key="$indexAnswer">
                              <v-checkbox v-model="answer.correct" @click="changeCorrect($index)" color="blue"
                                          tabindex="-1"></v-checkbox>
                              <v-text-field v-model="answer.text" label="Resposta" required class="v-text-field-answer"
                                            solo></v-text-field>
                              <v-icon v-if="question.answers.length > 4" @click="removeAnswer($index, $indexAnswer)" color="red"
                                      dark>cancel
                              </v-icon>
                            </v-layout>
                            -->

                            <v-col md="12" class="add-answer p-0" v-if="quiz.questions[$index].answers.length < 6">
                              <v-btn :disabled="sending" @click="addAnswer($index)" color="primary" dark class="ml-0">
                                Adicionar
                                resposta
                              </v-btn>
                            </v-col>
                          </v-badge>
                        </div>

                      </v-col>
                    </v-row>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions class="btns-action">
          <v-btn color="primary" dark :to="{name:'course-create-step3', params: {courseId}}" :disabled="sending"
                 class="mt-3 ml-0 text-white">Voltar
          </v-btn>
          <v-divider></v-divider>
          <v-btn color="primary" dark @click="concludeQuiz" :disabled="sending" class="mt-3 ml-0">
            Concluir
          </v-btn>
        </v-card-actions>

      </v-card>

      <v-snackbar
        v-model="alert.show"
        bottom
        :color="alert.color"
      >
        {{ alert.text }}
      </v-snackbar>

    </template>
  </user-course-register>
</template>

<script>
import UserCourseRegister from '@/views/User/CourseRegister'
import { VueEditor } from 'vue2-editor'
import { QuizModel } from '@/models/Quiz'
import { swalConfirm } from '@/helpers'

export default {
  name: 'UserCourseRegisterStep4',
  components: {
    UserCourseRegister, VueEditor
  },
  data: () => {
    return {
      loading: false,
      loadingModules: false,
      loadingQuiz: false,
      moduleSelect: null,
      moduleSelectBack: null,
      moduleSelectRedirect: false,
      oldVal: null,
      indexSelected: null,
      modules: [],
      moduleId: null,
      moduleTitle: null,
      moduleHasQuiz: false,
      showQuiz: false,
      sending: false,
      quiz: new QuizModel({}),
      alert: {
        show: false,
        text: null,
        color: null
      },
    }
  },
  computed: {
    courseId: function () {
      return this.$route.params.courseId
    },
    courseHasModules () {
      return !!this.modules.length
    },
  },
  watch: {
    showQuiz (val) {
      if (val && !this.courseHasModules) {
        this.quiz.course = this.courseId
      }
    }
  },
  created () {
    this.getCourseQuiz()
    this.getModules()
  },
  methods: {
    getQuiz (moduleId) {
      return this.axios.get(`/user/quiz/module/${moduleId}`)
    },
    getCourseQuiz () {
      this.axios.get(`/user/quiz/course/${this.courseId}`).then(({ data }) => {
        if (data.success && data.quiz) {
          this.showQuiz = true
          this.quiz = new QuizModel(data.quiz)
        }
      })
    },
    getModules () {
      this.loadingModules = true
      this.axios.get(`/user/course/modules/${this.courseId}`).then(({ data }) => {
        if (data.success) {
          this.modules = data.modules

          if (data.modules.length) {
            this.showQuiz = true
          }
        }
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        this.loadingModules = false
      })
    },
    addQuestion () {
      if (this.validate()) {
        this.quiz.questions.unshift({
          ask: '',
          answers: [
            { text: null, correct: false },
            { text: null, correct: false },
            { text: null, correct: false },
            { text: null, correct: false }
          ]
        })
      }
    },
    addAnswer (indexQuestion) {
      this.quiz.questions[indexQuestion].answers.push({
        text: null,
        correct: false
      })
    },
    removeQuestion (index) {
      if (this.quiz.questions.length > 1) {
        this.quiz.questions.splice(index, 1)
      }
    },
    removeAnswer (indexQuestion, indexAnswer) {
      if (this.quiz.questions[indexQuestion].answers.length > 1) {
        this.quiz.questions[indexQuestion].answers.splice(indexAnswer, 1)
      }
    },

    async selectModuleGetQuiz (module) {
      try {
        this.loadingQuiz = true

        const resultQuiz = await this.getQuiz(module._id)

        if (resultQuiz.data.success) {
          if (resultQuiz.data.quiz) {
            this.quiz = resultQuiz.data.quiz
            this.moduleHasQuiz = true
          } else {
            this.quiz = new QuizModel({ module: module._id })
            this.moduleHasQuiz = false
          }
        } else {
          await this.$swal('Ops', resultQuiz.data.message || 'Erro ao trazer o Quiz do módulo', 'error')

          return false
        }
      } catch (e) {
        console.error(e)
      }

      this.loadingQuiz = false
    },

    async selectModuleSaveQuiz () {
      try {
        this.sending = true
        const result = await this.saveQuiz()

        if (result) {
          if (result.data.success) {
            this.alert.color = 'success'
            this.alert.text = `Quiz do módulo ${this.moduleTitle} salvo com sucesso`
            this.alert.show = true
          } else {
            this.alert.color = 'error'
            this.alert.text = `Erro ao salvar o Quiz`
            this.alert.show = true

            this.sending = false

            return false
          }
        } else {
          this.sending = false

          return false
        }

        this.sending = false

        return true
      } catch (e) {
        console.error(e)
        this.sending = false

        return false
      }
    },

    async selectModule (module) {
      if (!this.moduleId) {
        await this.selectModuleGetQuiz(module)
      } else {
        if (this.moduleHasQuiz) {
          const resultSave = await this.selectModuleSaveQuiz(module)
          if (!resultSave) {
            return false
          }
        } else {
          if (this.quiz._id) {
            try {
              await swalConfirm({
                title: `Confirma a exclusão do quiz do módulo ${this.moduleTitle}?`,
                text: 'Esse ação não poderá ser desfeita',
                type: 'warning',
              })

              const resultDelete = await this.deleteQuiz(this.quiz._id)
              if (!resultDelete.data.success) {
                await this.$swal('Ops', resultDelete.data.message || 'Erro ao remover o quiz', 'error')
              } else {
                this.alert.text = 'Quiz excluído com sucesso'
                this.alert.color = 'success'
                this.alert.show = true
              }
            } catch (e) {
              this.moduleHasQuiz = true
            }
          }
        }
        await this.selectModuleGetQuiz(module)
      }

      this.moduleId = module._id
      this.moduleTitle = module.title
    },
    validate () {
      if (this.showQuiz) {
        if (!this.quiz.title) {
          this.$swal('Ops', 'Preencha o título do Quiz', 'error')

          return false
        }

        if (!this.quiz.questions.length) {
          this.$swal('Ops', 'Insira uma Pergunta', 'error')

          return false
        }

        for (let i = 0; i < this.quiz.questions.length; i++) {
          if (!this.quiz.questions[i].ask) {
            this.$swal('Ops', `Preencha a Pergunta da ${(this.quiz.questions.length - i)}ª questão`, 'error')

            return false
          }
          if (!this.quiz.questions[i].answers || this.quiz.questions[i].answers.length < 4) {
            this.$swal('Ops', `A questão ${this.quiz.questions[i].ask} deve ter no mínimo 4 alternativas`, 'error')

            return false
          }

          for (let k = 0; k < this.quiz.questions[i].answers.length; k++) {
            if (!this.quiz.questions[i].answers[k].text) {
              this.$swal('Ops', `Preencha o texto de todas as respostas da questão ${this.quiz.questions[i].ask}`, 'error')

              return false
            }
          }

          let indexCorrect = this.quiz.questions[i].answers.findIndex(answer => {
            return answer.correct
          })

          if (indexCorrect === -1) {
            this.$swal('Ops', `Seleciona uma alteranativa correta para a questão ${this.quiz.questions[i].ask}`, 'error')

            return false
          }
        }
      }

      return true
    },

    deleteQuiz (quizId) {
      return this.axios.delete(`/user/quiz/${quizId}`)
    },

    saveQuiz () {
      if (!this.validate()) {
        return false
      }
      return this.axios.request({
        url: '/user/quiz',
        method: (this.quiz._id ? 'PUT' : 'POST'),
        data: this.quiz,
        onUploadProgress: progressEvent => {
          // this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        }
      })
    },

    concludeQuiz () {
      if (!this.showQuiz && !this.quiz._id) {
        this.$swal('Sucesso', 'Curso registrado com sucesso', 'success').then(() => {
          this.$router.push({ name: 'course-my' })
        })
      }

      if (!this.showQuiz && this.quiz._id) {
        swalConfirm({
          title: `Confirma a exclusão do quiz do curso?`,
          text: 'Esse ação não poderá ser desfeita',
          type: 'warning',
        }).then(() => {
          this.deleteQuiz(this.quiz._id).then(({ data }) => {
            if (!data.success) {
              this.$swal('Ops', data.message || 'Erro ao remover o quiz', 'error')
            } else {
              this.$swal('Sucesso', 'Curso atualizado com sucesso', 'success').then(() => {
                this.$router.push({ name: 'course-my' })
              })
            }
          })
        })
      }

      if (this.showQuiz) {
        this.saveQuiz().then(({ data }) => {
          if (data.success) {
            this.$swal('Sucesso', 'Curso registrado com sucesso', 'success').then(() => {
              this.$router.push({ name: 'course-my' })
            })
          } else {
            this.$swal(
              'Ops',
              (data.message || 'Erro ao excluir o quiz'),
              'error'
            )
          }
        }).catch(err => {
          console.error(err)

          this.$swal(
            'Ops',
            'Erro ao excluir o quiz',
            'error'
          )
        })
      }
    }
  }
}
</script>
<style scoped>
.v-badge {
  width: 100%
}
</style>
